export default __webpack_public_path__ + "static/media/_ic_follow_whale.d64ca2dc.svg";